module.exports = __webpack_public_path__ + "static/img/banner.f03c27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner.png
// module id = RM3D
// module chunks = 1